import { PencilSimpleLine } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import Checkbox from "common/components/ui/Checkbox";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import Label from "common/components/ui/Label";
import type { ScheduleInterval } from "common/types";

import RangesSelect from "../RangesSelect";

interface EditScheduleIntervalProps {
  day: string;
  ranges: ScheduleInterval[];
  isDisabled: boolean;
  setRanges: (ranges: ScheduleInterval[]) => void;
  onApplyToAll: (ranges: ScheduleInterval[]) => void;
}

export default function EditScheduleInterval({
  day,
  ranges,
  isDisabled,
  setRanges,
  onApplyToAll,
}: EditScheduleIntervalProps) {
  const [currentRanges, setCurrentRanges] = useState(ranges);
  const [shouldApplyToAll, setShouldApplyToAll] = useState(false);
  const isEnabled = !!ranges.length;

  return (
    <Drawer onAfterClose={() => setCurrentRanges(ranges)}>
      <DrawerTrigger asChild>
        <Button
          variant="ghost-black"
          intent="iconOnly"
          disabled={!isEnabled || isDisabled}
        >
          <PencilSimpleLine />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <h5 className="-mx-4 mb-6 border-b border-black-200 px-4 pb-4 text-xl-bold capitalize">
          {day} schedule
        </h5>

        <RangesSelect
          isDisabled={isDisabled}
          ranges={currentRanges}
          setRanges={setCurrentRanges}
        />

        <div className="mt-4 flex items-center gap-1">
          <Checkbox
            id="applyToAll"
            checked={shouldApplyToAll}
            onCheckedChange={(checked: boolean) => {
              setShouldApplyToAll(checked);
            }}
          />
          <Label htmlFor="applyToAll">Apply to all days</Label>
        </div>

        <DrawerClose asChild>
          <Button
            className="mb-2 mt-8"
            onClick={() => {
              setRanges(currentRanges);
              if (shouldApplyToAll) {
                onApplyToAll(currentRanges);
              }
              setShouldApplyToAll(false);
            }}
          >
            Save and close
          </Button>
        </DrawerClose>
      </DrawerContent>
    </Drawer>
  );
}
